module.exports = __webpack_public_path__ + "img/google-badge.c23a1ecb.svg";